import { getAuthAxiosBackend } from "../../helpers/axios"

class MartyrServices{

    get(id){
        return getAuthAxiosBackend().get('plots-of-land-2/martyrs/'+id.toString())
    }

    getAll(data = {}){
        return getAuthAxiosBackend().get('plots-of-land-2/martyrs', {params: data})
    }

    delete(id){
        return getAuthAxiosBackend().delete('plots-of-land-2/martyrs/' + id)
    }
}

export default new MartyrServices()